import React from 'react';
import { GradientTextAction, Poppins } from 'src/common';
import { Dropzone } from './styles';
import { DropzoneRootProps, DropzoneInputProps } from 'react-dropzone';

interface CsvDropzoneWithTemplateProps {
  getRootProps: <T extends DropzoneRootProps>(props?: T) => T;
  getInputProps: <T extends DropzoneInputProps>(props?: T) => T;
  isDragActive: boolean;
  file: File | null;
  templateLink: string;
  templateFileName: string;
  onTemplateClick?: () => void;
}

export const CsvDropzoneWithTemplate: React.FC<CsvDropzoneWithTemplateProps> = ({
  getRootProps,
  getInputProps,
  isDragActive,
  file,
  templateLink,
  templateFileName,
  onTemplateClick,
}) => {
  return (
    <Dropzone {...getRootProps()}>
      <div style={{ position: 'absolute', right: 8, top: 8 }} onClick={(e) => e.stopPropagation()}>
        <a href={templateLink} download={templateFileName} style={{ textDecoration: 'none' }} onClick={onTemplateClick}>
          <GradientTextAction $underline weight={500} px={14}>
            Download CSV Template
          </GradientTextAction>
        </a>
      </div>
      <input {...getInputProps()} />
      {file ? (
        <Poppins px={14}>File selected: {file.name}</Poppins>
      ) : (
        <Poppins px={14} weight={500}>
          {isDragActive ? 'Drop the file here ...' : 'Drag and drop a file here, or click to select file'}
        </Poppins>
      )}
    </Dropzone>
  );
};
